import React, { useEffect } from 'react';
import { useNotifications } from '@/contexts/NotificationContext';
import { setInternalNotificationHandler } from '@/services/birthdayNotificationService';

const NotificationHandler: React.FC = () => {
  const { addNotification } = useNotifications();

  useEffect(() => {
    // Configurar o handler para o serviço de aniversário
    setInternalNotificationHandler(addNotification);
    
    console.log('🔔 NotificationHandler configurado - notificações internas ativas');
  }, [addNotification]);

  return null; // Este componente não renderiza nada
};

export default NotificationHandler;
